// @flow
import { GET_APP_SETTINGS, RECEIVE_APP_SETTINGS, SET_APP_SETTINGS } from './constants';

import { createAction } from 'redux-actions';

export const getAppSettings = createAction(GET_APP_SETTINGS);
export const receiveAppSettings = createAction(RECEIVE_APP_SETTINGS);
export const setAppSettings = createAction(SET_APP_SETTINGS);



// WEBPACK FOOTER //
// ./src/core/state/app-settings/actions.js